import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import LoadingSkeleton from "@/components/layout/LoadingSkeleton";

// Direct imports for true code splitting - each page loads independently
const NotFound = lazy(() => import("@/components/layout/feedback/NotFound"));

const LandingPage = lazy(() => import("@/features/home/HomePage"));

const AboutPage = lazy(() => import("@/features/about/AboutPage"));

const ContactsPage = lazy(() => import("@/features/contacts/ContactsPage"));

const PrivacyPolicyPage = lazy(() => import("@/features/legal/PrivacyPage"));

const PricesPage = lazy(() => import("@/features/prices/PricesPage"));

const ServiceDetailPage = lazy(() => import("@/features/services/ServiceDetailPage"));

const CoursesPage = lazy(() => import("@/features/courses/CoursesPage"));

const Router = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Suspense fallback={<LoadingSkeleton />}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/prices" element={<PricesPage />} />
        <Route path="/courses" element={<CoursesPage />} />

        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default Router;
